var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{on:{"click":function($event){return _vm.sendParticle(1)}}},[_vm._v("Send Particle")]),_c('b-button',{staticClass:"ml-3",on:{"click":_vm.download}},[_vm._v("Download Log")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }